import { gql } from '@apollo/client';

export default gql`
    query loadCustomBoardsQuery($startIndex: Int, $stopIndex: Int, $filterBy: [JSON], $orderBy: [JSON], $excludeBy: [JSON]) {
        records: entities(type: "custom", startIndex: $startIndex, stopIndex: $stopIndex, filterBy: $filterBy, orderBy: $orderBy, excludeBy: $excludeBy) {
            id
            name
            type
            iconName
            iconColor
        }
    }
`;
